import apiClient from "./apiClient";

export const registerAdmin = (data) => {
    return apiClient.post('/Admin/Register', data);
};

export const loginAdmin = (data) => {
    return apiClient.post('/Admin/Login', data);
};

export const resetPassword = (token, data) => {
    return apiClient.post(`/Admin/ResetPassword`, data);
};

